module.exports = "./../img/ipad-iphone-markant-facebook.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ipad-iphone-markant-facebook.png
// module id = 154
// module chunks = 0